/**
 * 资产管理
 */
import http from '@/http'

export default {
  // 资产清单列表
  getAssetsList(params) {
    return http.get('/asset', {
      params,
      paramsSerializer(queryParams = {}) {
        const searchParams = new URLSearchParams()
        Object.keys(queryParams).forEach(key => {
          const value = queryParams[key]
          if (value === undefined || value === null || value === '') return
          if (Array.isArray(value)) {
            value.forEach(item => {
              if (item !== undefined && item !== null && item !== '') {
                searchParams.append(key, item)
              }
            })
            return
          }
          searchParams.append(key, value)
        })
        return searchParams.toString()
      }
    })
  },
  // 根据工具编号或 RFID 查询关键工具详情
  getAssetDetailByKeyword(params) {
    return http.get('/asset/detail', { params })
  },
  // 保存资产信息
  saveAssets(params) {
    return http.post('/asset', params)
  },
  // 复制资产信息
  copyAssets(params) {
    return http.post('/asset/copy', params)
  },
  // 删除资产信息
  deleteAssets(params) {
    return http.post('/asset/delete', params)
  },
  // 查询盘点记录
  getAssetsCheck(params) {
    return http.get('/asset/check', {params})
  },
  // 保养设置分页查询
  getMaintainSettingPage(params) {
    return http.get('/asset/maintain/setting/page', { params })
  },
  // 保存保养设置
  saveMaintainSetting(params) {
    return http.post('/asset/maintain/setting', params)
  },
  // 保养设置详情
  getMaintainSettingDetail(id) {
    return http.get(`/asset/maintain/setting/detail/${id}`)
  },
  // 删除保养设置
  deleteMaintainSetting(params) {
    return http.post('/asset/maintain/setting/delete', params)
  },
  // 保养记录分页查询
  getMaintainRecordPage(params) {
    return http.get('/asset/maintain/record/page', { params })
  },
  // 保养记录详情
  getMaintainRecordDetail(id) {
    return http.get(`/asset/maintain/record/detail/${id}`)
  },
  // 资产分析
  getAssetAnalysis(id) {
    return http.get(`/asset/analysis/${id}`)
  },
  // 根据资产id或资产编号查询已使用次数
  getAssetUsedTimes(params) {
    return http.get('/asset/used-times', { params })
  },
  // 单独更新保养记录中的已使用次数
  updateMaintainRecordUsedTimes(params) {
    return http.post('/asset/maintain/record/used-times', params)
  },
  // 删除保养记录
  deleteMaintainRecord(params) {
    return http.post('/asset/maintain/record/delete', params)
  },
  // 保养记录 按工段统计(总数/已保养/待保养)
  getMaintainRecordStationStatistics(params) {
    return http.get('/asset/maintain/record/station-statistics', { params })
  },
  // 根据资产类型查询资产列表
  getAssetsByTypes(params) {
    return http.get('/asset/by-type', {
      params,
      paramsSerializer(queryParams = {}) {
        const searchParams = new URLSearchParams()
        Object.keys(queryParams).forEach(key => {
          const value = queryParams[key]
          if (value === undefined || value === null || value === '') return
          if (Array.isArray(value)) {
            value.forEach(item => {
              if (item !== undefined && item !== null && item !== '') {
                searchParams.append(key, item)
              }
            })
            return
          }
          searchParams.append(key, value)
        })
        return searchParams.toString()
      }
    })
  },
  // 盘点记录详情
  getAssetsCheckDetail(params) {
    return http.get('/asset/check/detail', {params})
  },
  // 工具寿命列表
  getAssetsLife(params) {
    return http.get('/pts', {params})
  },
  // 工具寿命预警统计(按工段/班组分组,自适应角色维度)
  getPtsLifeWarnStatistics(params) {
    return http.get('/pts/life-warn-statistics', { params })
  },
  // 根据工具名称模糊查询工具基本信息
  searchToolBasic(params) {
    return http.get('/pts/search', {params})
  },
  // 导出已预警的寿命数据（POST + query params + blob）
  exportPTSWarningData(params = {}) {
    return http.post('/pts/export/warning', null, {
      params,
      responseType: 'blob',
      isFile: true
    }).then(res => {
      const disposition = res.headers['content-disposition'] || ''
      let filename = ''
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      if (match && match[1]) {
        filename = decodeURI(match[1].replace(/['"]/g, ''))
      }
      const blob = new Blob([res.data], { type: res.data.type || 'application/octet-stream' })
      const blobURL = window.URL.createObjectURL(blob)
      const aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = blobURL
      aLink.download = filename
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      window.URL.revokeObjectURL(blobURL)
    })
  },
  // 保存工具寿命信息
  saveTool(params) {
    return http.post('/pts', params)
  },
  // 标记已更换
  signChanged(params) {
    return http.post('/pts/changed', params)
  },
  // 作废
  signInvalid(params) {
    return http.post('/pts/cancel', params)
  },
  // 设置PTS数据频率
  setPTSFrequency(params) {
    return http.post('/pts/data-rate', params)
  },
  // 上传工具导入文件
  importTools(formData) {
    return http.post('/pts/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 查询工具导入中转数据
  getToolImportStaging(params) {
    return http.get('/pts/import', {params})
  },
  // 确认导入选中的工具数据
  confirmToolImportStaging(params) {
    return http.post('/pts/import/confirm', params)
  },
  // 编辑工具导入中转数据
  updateToolImportStaging(params) {
    return http.put('/pts/import/staging', params)
  },
  // 删除工具导入中转数据
  deleteToolImportStaging(params) {
    return http.delete('/pts/import/staging', { params })
  },
  // 获取非关键工具列表
  getNonkeytoolList(params) {
    return http.get('/nonasset', {params})
  },
  // 根据工具编号或名称查询非关键工具详情
  getNonkeytoolDetailByKeyword(params) {
    return http.get('/nonasset/detail', { params })
  },
  // 查询非关键工具关联工位（异常上报选择工具使用）
  getNonkeytoolLocationList(params) {
    return http.get('/nonasset/ref/list', { params })
  },
  // 保存非关键工具
  saveNonkeyTool(params) {
    return http.post('/nonasset', params)
  },
  // 删除非关键工具
  delNonkeyTool(params) {
    return http.post('/nonasset/delete', params)
  },
  // 查询关联工位列表
  getAssociatedStationList(params) {
    return http.get('/nonasset/ref', {params})
  },
  // 添加关联工位
  saveAssociatedStation(params) {
    return http.post('/nonasset/ref', params)
  },
  // 删除关联工位
  deleteAssociatedStation(params) {
    return http.post('/nonasset/ref/delete', params)
  },
  // 查询点检项列表
  getCheckItemList(params) {
    return http.get(`/nonasset/tpm-items/${params}`)
  },
  // 保存点检项
  saveCheckItem(params) {
    return http.post('/nonasset/tpm-items', params)
  },
  // 删除点检项
  delCheckItem(params) {
    return http.post('/nonasset/tpm-items/delete', params)
  },
  // 复位
  resetAssets(params) {
    return http.post('/asset/reset/current-emp-station', params)
  },
  // 查询点检项列表
  getAssetTpmItems(params) {
    return http.get(`/asset/o2o/tpm`, {params})
  },
  saveAssetTpmItem(params){
    return http.post('/asset/o2o/tpm', params)
  },
  getAssetPtsItems(params){
    return http.get(`/asset/pts-items`, {params})
  },
  saveAssetPtsItems(params){
    return http.post(`/asset/pts-items`, params)
  },
  // 校验资产编号是否已存在
  checkCodeExists(params) {
    return http.get('/asset/exists/code', {params})
  },
  // 校验 RFID 是否已存在
  checkRfidExists(params) {
    return http.get('/asset/exists/rfid', {params})
  },
  // 上传导入文件
  importAssets(formData) {
    return http.post('/asset/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  // 查询导入中间表数据
  getImportStaging(params) {
    return http.get('/asset/import', {params})
  },
  // 确认导入选中数据
  confirmImportStaging(params) {
    return http.post('/asset/import/confirm', params)
  },
  // 编辑导入中间表记录（导入确认前修正数据）
  updateImportStaging(params) {
    return http.put('/asset/import/staging', params)
  },
  // 删除导入中间表数据
  deleteImportStaging(params) {
    return http.post('/asset/import/staging/delete', params)
  },
  // 导出资产信息（POST + blob）
  exportAssets(params = {}) {
    return http.post('/asset/export', params, {
      responseType: 'blob',
      isFile: true,
      headers: { 'Content-Type': 'application/json' }
    }).then(res => {
      const disposition = res.headers['content-disposition'] || ''
      let filename = ''
      const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/)
      if (match && match[1]) {
        filename = decodeURI(match[1].replace(/['"]/g, ''))
      }
      const blob = new Blob([res.data], { type: res.data.type || 'application/octet-stream' })
      const blobURL = window.URL.createObjectURL(blob)
      const aLink = document.createElement('a')
      aLink.style.display = 'none'
      aLink.href = blobURL
      aLink.download = filename
      document.body.appendChild(aLink)
      aLink.click()
      document.body.removeChild(aLink)
      window.URL.revokeObjectURL(blobURL)
    })
  },
  // 工位工具配备统计块（新接口）
  getEmpStationConfigStat() {
    return http.get('/asset/emp-station-config/stat')
  },
  // 资产状态分组统计（按工段/班组）
  getAssetStatusGroupStat(params) {
    return http.get('/asset/statistic/status-group', { params })
  },
  // 工位工具配备详情分页（新接口）
  getEmpStationConfigDetail(params) {
    return http.get('/asset/emp-station-config/detail', { params })
  }
}
